import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Privacy Policy`}</h2>
    <p>{`Your trust in HostJane is paramount, and we take our responsibility to protect your information seriously. We are dedicated to safeguarding your data and empowering you with control over it.`}</p>
    <h2>{`1. OUR COMMITMENT TO YOUR PRIVACY: WORLD-CLASS DATA SECURITY`}</h2>
    <p><strong parentName="p">{`1.1`}</strong>{` HostJane, Inc. (“We,” “Us”, "Our", or “HostJane”) is a hybrid infrastructure provider of marketplace, ecommerce, and web hosting services, helping startups, small businesses, and individuals to do more rewarding work with
third-party freelancers, establish and build their web presence, get found in online search,
and attract and retain more customers than their competition.`}</p>
    <p><strong parentName="p">{`US-Based, Encrypted Servers`}</strong>{`: All data is securely stored on encrypted AWS servers located in the United States, adhering to the highest industry standards for data protection.`}</p>
    <p><strong parentName="p">{`Confidential Seller Data`}</strong>{`: Your seller data is kept strictly confidential and stored on encrypted, US-based Amazon Web Services (AWS) servers, leveraging Amazon’s world-class security. We do not collect or store your payment information; it is handled securely by our trusted payment partners to process your orders.`}</p>
    <p><strong parentName="p">{`Isolated Delivery Addresses`}</strong>{`: Wishlist delivery addresses, such as those for Harrods Hamper orders, are stored separately from other data to ensure enhanced privacy and security.`}</p>
    <p><strong parentName="p">{`1.2`}</strong>{` We care about protecting the personal information of all Our customers and visitors who use Our
websites, products or services (collectively, Our “Users”). This privacy notice provides details
about how Your personal information is collected, shared and used by Us. `}</p>
    <p><strong parentName="p">{`Robust Security Measures`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`SSL Encryption`}</strong>{`: We use 256-bit SSL encryption to ensure your data is transmitted securely.`}</li>
      <li parentName="ul"><strong parentName="li">{`Advanced Authentication`}</strong>{`: Our login systems integrate state-of-the-art Google, Apple, Telegram, and X authentication for secure access.`}</li>
      <li parentName="ul"><strong parentName="li">{`Database Compliance`}</strong>{`: Our databases meet the highest ISO and SOC compliance standards for maximum security.`}</li>
      <li parentName="ul"><strong parentName="li">{`Secure Checkout`}</strong>{`: We partner with leading payment providers to offer a seamless and secure checkout experience.`}</li>
    </ul>
    <p>{`Your privacy and security are our top priorities, and we continuously strive to maintain the highest standards in protecting your information.`}</p>
    <p><strong parentName="p">{`1.3`}</strong>{` To learn more about HostJane, Inc, visit: `}<a parentName="p" {...{
        "href": "https://www.69work.com"
      }}>{`https://www.69work.com`}</a></p>
    <p><strong parentName="p">{`1.4`}</strong>{` For the purposes of the European Union’s General Data Protection Regulation 2016/679, or GDPR,
HostJane, Inc, is the data controller when You use a product or Service authored by Us. This does
not apply to third-party services provided by Our Users.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      